import React from "react"

import { useRef} from "react"

import useOnScreen from "../hooks/useOnScreen"

import "../styles/contentSection.css"

export default function ContentSection({ className, background, children}) {
		
	const ref = useRef()
	
	const sectionVisible = useOnScreen(ref)
	
	return (
		<section ref={ref} style={ { background: background}} className={`content-section${ sectionVisible ? " kn-section-visible" : ""} ${ className}`}>	
			
			<div className="content-outer-section">
			
				{ children}
			</div>	
		</section>
	)
}